module.exports = __webpack_public_path__ + "static/media/Illustration4.df92c811.png";